import React from 'react';
import { graphql } from 'gatsby';
import classnames from 'classnames';
import SanityPortableText from '../SanityPortableText';
import { getImageDimensions } from '@sanity/asset-utils';

import PancakeIntro from '../PancakeIntro';
import Pancake from './Pancake';
import Container from '../Container';
import Button from '../Button';

import './Benefits.scss';

const Benefits = (props) => {
  const { title, text, benefits, callToAction, theme, className } = props;

  return (
    <Pancake className={classnames('PancakeBenefits', className)} theme={theme}>
      <Container>
        {(title || text) && <PancakeIntro title={title} text={text} />}
        {benefits?.length > 0 && (
          <div className="PancakeBenefitsGrid">
            {benefits.map((benefit) => {
              const imageSize = benefit.icon
                ? getImageDimensions(benefit.icon)
                : undefined;

              return (
                <div>
                  {benefit.icon && (
                    <img
                      src={benefit.icon.asset.url}
                      alt={''}
                      loading="lazy"
                      className="PancakeBenefitsIcon"
                      width={imageSize?.width}
                      height={imageSize?.height}
                    />
                  )}
                  {benefit.title && (
                    <h3 className="PancakeBenefitsTitle">{benefit.title}</h3>
                  )}
                  {benefit._rawText && (
                    <SanityPortableText blocks={benefit._rawText} />
                  )}
                </div>
              );
            })}
          </div>
        )}
        {callToAction?.url && callToAction?.label && (
          <div className="PancakeBenefitsCTA">
            <Button
              to={callToAction?.url}
              className="corporate-light with-shadow"
              arrow
            >
              {callToAction?.label}
            </Button>
          </div>
        )}
      </Container>
    </Pancake>
  );
};

export const query = graphql`
  fragment SanityPancakeBenefits on SanityPancakeBenefits {
    _key
    _type
    pancakeIntro {
      pancakeText
      pancakeTitle
    }
    callToAction {
      url
      label
    }
    benefits {
      title
      _rawText(resolveReferences: { maxDepth: 1000 })
      icon {
        asset {
          url
        }
      }
    }
    theme
  }
`;

export default Benefits;
